export const PACKAGE_FIELD_HELP = {
  gradingType:
    "Tipo de serviço de grading desta linha do pacote (Premium, sem subgrades, PRE, etc.).",
  numberOfCards:
    "Quantidade de cartas desta linha. O pacote pode misturar tipos (ex.: 1 Premium + 5 sem subgrades).",
  autograph:
    "Avaliação de autógrafo nesta linha. Indisponível em Premium; desmarque se não fizer parte da oferta.",
  promoPrice:
    "Preço total fixo do pacote em reais — o que o cliente paga pela oferta fechada, independente da tabela.",
  promoDeadline:
    "Prazo fixo da promoção em dias úteis. Não usa prioridade do checkout; você define o número à mão.",
  referenceAnchor:
    "Preços de referência da tabela (sem manuseio/frete) para comparar a economia. Só âncora — não é o preço de venda.",
  title:
    "Título público da oferta (vitrine/carrinho). Pode gerar com IA e editar depois.",
  subtitle:
    "Texto de apoio público: benefício, economia ou prazo. Pode gerar com IA e editar depois.",
  internalName:
    "Nome só para o admin (lista e busca). O cliente não vê este campo.",
  slug:
    "Identificador único em URL (minúsculas, números e hífens). Gera sozinho a partir do nome interno; pode ajustar.",
  startsAt:
    "Início da vigência. Fora desta janela o pacote não fica elegível mesmo se estiver marcado como ativo.",
  endsAt:
    "Fim da vigência (inclusive no dia). Depois desta data o pacote deixa de valer.",
  isActive:
    "Liga/desliga a oferta. Precisa estar ativo e dentro de início/fim para aparecer quando o client consumir.",
  image:
    "Imagem opcional do card. Sem arquivo, o preview usa tipografia, quantidade, economia e preço.",
};
